import {
    errorHelper, uploadData,
} from '@/store/config/methodCsrf'

const initialState = () => ({
    fileDetail: {
        name: null,
        fullName: null,
    },
})
const state = initialState
const getters = {
    getItem: state => state.item,
    getMsg: state => state.msg,
    getStatus: state => state.status
}
function createChunks(file) {
    const size = 2097152; const chunks = Math.ceil(file.size / size)
    const temp = []
    for (let i = 0; i < chunks; i++) {
      temp.push(file.slice(
        i * size, Math.min(i * size + size, file.size), file.type,
      ))
    }
    return temp
}
const actions = {
    async uploadDataToServer({dispatch}, fileData) {
        try{
            if (!fileData.file)
                return { status: 0, data: {} }
        
            const chunks = createChunks(fileData.file)
            let fileDetail = {}
            for (let i = 0; i < chunks.length; i++) {
                const formData = new FormData()
                const is_last = (i === chunks.length - 1) ? '1' : '0'
                formData.set('is_last', is_last)
                formData.set('file', chunks[i], `${fileData.name}.part`)
        
                if (is_last === '1') {
                    formData.set('description', fileData.description)
                    formData.set('size', fileData.size)
                    formData.set('created_by', fileData.created_by)
                }
        
                if (fileData.file_group_ids && fileData.file_group_ids.length) {
                    fileData.file_group_ids.forEach((id) => {
                        if (!id)
                        return
            
                        formData.append('file_group_ids[]', id)
                    })
                }
        
                const { status, data } = await dispatch('uploadChunkedFile',{formData, name: fileData.name_file || fileData.name})
                fileDetail = data
                if (status === 0)
                    return { status: 0, data }
            }
            return { status: 1, data: fileDetail }
        }catch(e){
            console.log(e)
            return { status: 0, data: {} }
        }

    },
    async uploadChunkedFile({commit}, {formData, name}) {
        try {
          const url = `api/public/upload-file/${name}`
          const response = await uploadData('admin', url, formData, true)
          commit('SET_FILE_NEW_NAME',response.data.data)
          return response.data
        }
        catch (err) {
          return errorHelper(err)
        }
    },

    
}

const mutations = {
    SET_FILE_NEW_NAME(state,response) {
        state.fileDetail = {
          name: response.fileName,
          fullName: response.fullName,
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}